// Author: Jeff Van Boxtel (PNDLM)
//

// Redux Built-in Actions
export const REDUX_INIT = "@@redux/INIT"



// WEBPACK FOOTER //
// ./src/data/CurrentUserActions.js